/**
 * Client trace id — the trace id of the most recent user send, held in module
 * scope so non-React code (the reportError helper, error boundaries) can tag a
 * post-send crash with the in-flight agent run without prop-drilling or importing
 * the task store (which would create a circular dependency).
 *
 * Set by taskStore.sendMessage on each send. Mirrors clientIdentity.ts. Kept
 * separate from socketService on purpose: socketService is mocked by ~26 store
 * tests, and this module is not, so trace plumbing stays out of their way.
 */

let currentTraceId: string | undefined;

export const setCurrentTraceId = (id?: string): void => {
  currentTraceId = id;
};

export const getCurrentTraceId = (): string | undefined => currentTraceId;
